import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=07ceced2&"
import script from "./TermsOfService.vue?vue&type=script&lang=js&"
export * from "./TermsOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports